module.exports = __webpack_public_path__ + "img/album04_07.23da80ca.jpg";